var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Input } from "@/components/ui/input";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Frequency, RRule, RRuleSet, rrulestr } from "rrule";
import moment from "moment";
import useForm from "@/Utils/useForm";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import { Link, router } from '@inertiajs/react';
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
export default function AddSlotsForm(_a) {
    var _b;
    var team = _a.team, calendar = _a.calendar, startDate = _a.startDate, bookingSlot = _a.bookingSlot, setPreviewSlots = _a.setPreviewSlots, cancel = _a.cancel;
    var route = useRoute(Ziggy);
    var intervalOptions = [
        { label: "60min", value: "60" },
        { label: "30min", value: "30" },
    ];
    var durationOptions = [
        { label: "60min", value: "60" },
        { label: "45min", value: "45" },
        { label: "30min", value: "30" },
    ];
    var daysOfWeekMap = (_b = {},
        _b[RRule.MO.toString()] = RRule.MO,
        _b[RRule.TU.toString()] = RRule.TU,
        _b[RRule.WE.toString()] = RRule.WE,
        _b[RRule.TH.toString()] = RRule.TH,
        _b[RRule.FR.toString()] = RRule.FR,
        _b[RRule.SA.toString()] = RRule.SA,
        _b[RRule.SU.toString()] = RRule.SU,
        _b);
    var _rruleSet = bookingSlot.rule
        ? rrulestr(bookingSlot.rule, { forceset: true })
        : (function () {
            var rruleSet = new RRuleSet();
            rruleSet.rrule(new RRule({
                dtstart: startDate,
                until: null,
                interval: 1,
                freq: Frequency.WEEKLY,
                byweekday: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR],
                byhour: [],
                byminute: [],
            }));
            return rruleSet;
        })();
    var _c = useState(_rruleSet), rrule = _c[0], setRRule = _c[1];
    var _d = useState([]), timeOptions = _d[0], setTimeOptions = _d[1];
    var form = useForm(rruleToForm(bookingSlot, _rruleSet));
    function rruleToForm(bookingSlot, ruleSet) {
        var _a;
        var data = ruleSet.rrules()[0].origOptions;
        var slots = [];
        // foreach rrules
        for (var i = 0; i < ruleSet.rrules().length; i++) {
            var rrule_1 = ruleSet.rrules()[i].origOptions;
            if (rrule_1.byhour) {
                var hour = (rrule_1.byhour + "").length == 2 ? rrule_1.byhour : "0" + rrule_1.byhour;
                var minute = (rrule_1.byminute + "").length == 2 ? rrule_1.byminute : "0" + rrule_1.byminute;
                var slotStr = "".concat(hour, ":").concat(minute);
                console.log('slotStr', slotStr);
                slots.push(slotStr);
            }
        }
        var formData = {
            start: data.dtstart,
            end: data.until || null,
            daysOfWeek: (_a = data.byweekday) === null || _a === void 0 ? void 0 : _a.map(function (day) { return day.toString(); }),
            interval: bookingSlot.interval ? bookingSlot.interval + "" : "60",
            duration: bookingSlot.duration ? bookingSlot.duration + "" : "60",
            slots: slots.length > 0 ? slots : ["09:00", "10:00", "11:00", "12:00", "14:00", "15:00", "16:00", "17:00"],
            exDates: ruleSet.exdates().map(function (date) { return new Date(date); }),
        };
        console.log('formData', "=>", data, "=>", formData);
        return formData;
    }
    useEffect(function () {
        var newRuleSet = new RRuleSet();
        // Map through each slot to create an RRule for it
        form.data.slots.sort().forEach(function (slot) {
            var _a = slot.split(":").map(function (num) { return parseInt(num, 10); }), hour = _a[0], minute = _a[1];
            newRuleSet.rrule(new RRule({
                dtstart: new Date(form.data.start),
                interval: 1,
                freq: Frequency.WEEKLY,
                byweekday: form.data.daysOfWeek.map(function (day) { return daysOfWeekMap[day]; }),
                byhour: hour,
                byminute: minute,
                until: form.data.end ? new Date(form.data.end) : null,
            }));
        });
        // Map through each exDate to add it to the rule set
        form.data.exDates.forEach(function (date) {
            newRuleSet.exdate(new Date(date));
        });
        setRRule(newRuleSet);
        setupTimeOptions(form.data.interval);
        // Generate booking slots based on the RRuleSet
        var bookingSlots = newRuleSet.between(startDate, moment(startDate).endOf("week").toDate()).map(function (date) {
            return {
                $startDate: date,
                $endDate: moment(date).add(parseInt(form.data.duration), 'minutes').toDate(),
                $color: "gray",
            };
        });
        setPreviewSlots(bookingSlots);
    }, [form.data, startDate]); // Ensure `startDate` is a dependency if it's used from state or props
    useEffect(function () {
        console.log("rrule", rrule);
    }, [rrule]);
    function setupTimeOptions(interval) {
        var startTime = moment().startOf('day').add(6, 'hours');
        var endTime = moment().startOf('day').add(24, 'hours');
        var timeOptions = [];
        while (startTime.isBefore(endTime)) {
            timeOptions.push(startTime.format('HH:mm'));
            if (interval == "30") {
                startTime.add(30, 'minutes');
            }
            else {
                startTime.add(60, 'minutes');
            }
        }
        console.log('timeOptions', timeOptions);
        setTimeOptions(timeOptions);
    }
    useEffect(function () {
        setupTimeOptions(form.data.interval);
    }, [form.data]);
    // Handle the completion of the form
    var handleSave = function () {
        var fn = bookingSlot.id ? "put" : "post";
        var url = bookingSlot.id ? route('team.calendar.bookingSlot.update', {
            team: team,
            calendar: calendar,
            bookingSlot: bookingSlot.id
        }) : route('team.calendar.bookingSlot.store', { team: team, calendar: calendar });
        var data = JSON.parse(JSON.stringify({
            rrule: rrule.toString(),
            form: form.data,
        }));
        console.log("handleSave", url, data);
        router[fn](url, data, {
        // preserveState: true
        });
    };
    var destroy = function () {
        router.delete(route('team.calendar.bookingSlot.destroy', {
            team: team,
            calendar: calendar,
            bookingSlot: bookingSlot.id
        }), {
            preserveState: false
        });
    };
    function changeInterval(value) {
        // reset the slots
        console.log('changeInterval', value);
        // remove slots that do not fit the new interval
        var newSlots = form.data.slots.filter(function (slot) {
            var _a = slot.split(":").map(function (num) { return parseInt(num, 10); }), hour = _a[0], minute = _a[1];
            return value === "60" ? minute == 0 : true;
        });
        form.setData(__assign(__assign({}, form.data), { interval: value, duration: value, slots: newSlots }));
    }
    return (_jsx("div", __assign({ className: "rounded shadow" }, { children: _jsxs("div", __assign({ className: "p-4 bg-white max-w-lg" }, { children: [_jsx("div", __assign({ className: "mb-4 flex space-x-2 items-center" }, { children: _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(Label, __assign({ htmlFor: "option-until", className: " whitespace-nowrap text-sm opacity-75" }, { children: "Starts on" })), _jsx(Input, { type: "date", value: moment(form.data.start).format("YYYY-MM-DD"), onChange: function (e) { return form.setData(__assign(__assign({}, form.data), { start: new Date(e.target.value) })); } })] })) })), _jsx("div", __assign({ className: "mb-4 flex space-x-2 items-center" }, { children: _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(Label, __assign({ htmlFor: "option-end", className: " whitespace-nowrap text-sm opacity-75" }, { children: "Ends on" })), !form.data.end && _jsx("div", { children: _jsx("button", __assign({ className: "text-sm text-sky-600", onClick: function () {
                                        form.setData(__assign(__assign({}, form.data), { end: moment(form.data.start).toDate() }));
                                    } }, { children: "Add end date" })) }), form.data.end &&
                                _jsxs("div", __assign({ className: "flex" }, { children: [_jsx(Input, { type: "date", value: moment(form.data.end).format("YYYY-MM-DD"), onChange: function (e) { return form.setData(__assign(__assign({}, form.data), { end: moment(e.target.value).endOf("day").toDate() })); } }), _jsx("button", __assign({ className: "text-sm text-red-500 ml-2", onClick: function () {
                                                form.setData(__assign(__assign({}, form.data), { end: null }));
                                            } }, { children: "\u00D7" }))] }))] })) })), _jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 text-sm text-gray-600" }, { children: "Days of the week" })), _jsx("div", __assign({ className: "flex space-x-2" }, { children: _jsx(ToggleGroup, __assign({ size: "sm", type: "multiple", onValueChange: function (value) { return form.setData(__assign(__assign({}, form.data), { daysOfWeek: value })); }, value: form.data.daysOfWeek }, { children: Object.keys(daysOfWeekMap).map(function (day) { return (_jsx(ToggleGroupItem, __assign({ value: day }, { children: daysOfWeekMap[day].toString()[0] }), day)); }) })) }))] })), _jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 text-sm text-gray-600" }, { children: "Interval" })), _jsx("div", __assign({ className: "flex space-x-2" }, { children: _jsx(RadioGroup, __assign({ value: form.data.interval, className: "flex space-x-2", onValueChange: function (value) { return changeInterval(value); } }, { children: intervalOptions.map(function (option) { return _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(RadioGroupItem, { value: option.value, id: 'interval' + option.value }), _jsx(Label, __assign({ htmlFor: 'interval' + option.value }, { children: option.label }))] })); }) })) }))] })), _jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 text-sm text-gray-600" }, { children: "Duration" })), _jsx("div", __assign({ className: "flex space-x-2" }, { children: _jsx(RadioGroup, __assign({ value: form.data.duration, className: "flex space-x-2", onValueChange: function (value) { return form.setData('duration', value); } }, { children: durationOptions.filter(function (a) { return a.value <= form.data.interval; }).map(function (option) { return _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(RadioGroupItem, { value: option.value, id: 'duration' + option.value }), _jsx(Label, __assign({ htmlFor: 'duration' + option.value }, { children: option.label }))] })); }) })) }))] })), _jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 text-sm text-gray-600" }, { children: "Slots" })), _jsx("div", __assign({ className: "flex space-x-2" }, { children: _jsx(ToggleGroup, __assign({ size: "sm", className: "flex-wrap", type: "multiple", onValueChange: function (value) { return form.setData('slots', value); }, value: form.data.slots }, { children: timeOptions.map(function (val) { return (_jsx(ToggleGroupItem, __assign({ className: "text-xs", value: val }, { children: val }), val)); }) })) }))] })), form.data.exDates && form.data.exDates.length > 0 && (_jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 text-sm text-gray-600" }, { children: "Excluded dates" })), _jsx("div", __assign({ className: "flex flex-col space-y-1" }, { children: form.data.exDates.map(function (date) { return (_jsxs("div", __assign({ className: "text-xs flex justify-between w-full" }, { children: [moment.tz(date, "UTC").format('YYYY-MM-DD, HH:mm'), _jsx("button", __assign({ onClick: function () {
                                            form.setData('exDates', form.data.exDates.filter(function (d) { return d !== date; }));
                                        }, className: "text-red-500" }, { children: "\u00D7" }))] }), date)); }) }))] }))), _jsxs("div", __assign({ className: "flex space-x-4" }, { children: [_jsx(Button, __assign({ id: "save", onClick: handleSave }, { children: "Save" })), _jsx(Button, __assign({ asChild: true, variant: "outline" }, { children: _jsx(Link, __assign({ href: route('team.calendar.week', { team: team, calendar: calendar }) }, { children: "Cancel" })) })), bookingSlot.id && (_jsx(Button, __assign({ variant: "destructive", onClick: function () { return destroy(); } }, { children: "Delete" })))] }))] })) })));
}
